import { render, staticRenderFns } from "./IvyEvents.vue?vue&type=template&id=022706c6&"
import script from "./IvyEvents.vue?vue&type=script&lang=js&"
export * from "./IvyEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports